export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_14.ffde5683.jpg";